import { useState } from "react";
import { RecordingStatus } from "@zoom/videosdk";
import classNames from "classnames";
import { Button, Tooltip } from "@mui/material";

export interface RecordButtonProps {
  text: string;
  tipText: string;
  icon: string;
  hoverIcon: string;
  onClick?: () => void;
}

const recordStatusIcon = {
  text: "Status",
  tipText: "Record Status",
  icon: "icon-recording-animated",
  hoverIcon: "icon-recording-animated-hover",
};

export const getRecordingButtons = (
  status: RecordingStatus | "",
  isHost: boolean
) => {
  // Stopped = recording
  // Recording = pause recording/ stop recording
  // Paused = resume recording/ stop recording
  let buttons: RecordButtonProps[] = [];

  if (status === RecordingStatus.Stopped || status === "") {
    buttons = [
      {
        text: "Record",
        tipText: "Start Recording",
        icon: "icon-recording",
        hoverIcon: "icon-recording-hover",
      },
    ];
  } else if (status === RecordingStatus.Recording) {
    if (!isHost) return [recordStatusIcon];
    buttons = [
      recordStatusIcon,
      {
        text: "Pause",
        tipText: "Pause Recording",
        icon: "icon-recording-pause",
        hoverIcon: "icon-recording-pause-hover",
      },
      {
        text: "Stop",
        tipText: "Stop Recording",
        icon: "icon-recording-stop",
        hoverIcon: "icon-recording-stop-hover",
      },
    ];
  } else if (status === RecordingStatus.Paused) {
    if (!isHost) return [recordStatusIcon];
    buttons = [
      recordStatusIcon,
      {
        text: "Resume",
        tipText: "Resume Recording",
        icon: "icon-recording-resume",
        hoverIcon: "icon-recording-resume-hover",
      },
      {
        text: "Stop",
        tipText: "Stop Recording ?",
        icon: "icon-recording-stop",
        hoverIcon: "icon-recording-stop-hover",
      },
    ];
  }
  return buttons;
};

const RecordingButton = (props: RecordButtonProps) => {
  const { tipText, onClick } = props;
  const [_, setIsHover] = useState(false);
  return (
    <Tooltip title={tipText}>
      <Button
        endIcon={
          <svg
            id="Group_93443"
            data-name="Group 93443"
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 40 40"
          >
            <path
              id="Path_206754"
              data-name="Path 206754"
              d="M20,0A20,20,0,1,1,0,20,20,20,0,0,1,20,0Z"
              fill="#fff"
            />
            <g id="radio_button_checked_black_24dp" transform="translate(8 8)">
              <path
                id="Path_206765"
                data-name="Path 206765"
                d="M0,0H24V24H0Z"
                fill="none"
              />
              <circle
                id="Ellipse_1317"
                data-name="Ellipse 1317"
                cx="8"
                cy="8"
                r="8"
                transform="translate(4 4)"
                fill="#ff3939"
              />
            </g>
          </svg>
        }
        className={classNames("vc-button")}
        // icon={<IconFont type={isHover ? hoverIcon : icon} />}
        // eslint-disable-next-line react/jsx-boolean-value
        onClick={onClick}
        onMouseEnter={() => {
          setIsHover(true);
        }}
        onMouseLeave={() => {
          setIsHover(false);
        }}
      />
    </Tooltip>
  );
};

export { RecordingButton };
